/**
 * Machine epsilon gives an upper bound on the relative error due to rounding in floating point arithmetic.
 */
export const EPSILON = 1e-16
// @todo why not Number.EPSILON?

/**
 * Limit on the number of loops in algorithms.
 */
export const MAX_LOOPS = 512
